module.exports = __webpack_public_path__ + "img/banner-new3.f2ed4d58.png";